export default "__VITE_ASSET__DL2VXxFj__"